module.exports = __webpack_public_path__ + "static/media/Laugo_13-Recovered.fd38af4c.jpg";